<template>
    <div class="probootstrap-section">
        <div class="container containerBottom">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h4>合作伙伴</h4>
                </div>
            </div>
        </div>
        <div class="container ">
            <div class="row gan_10">
                <div class="st_tabContain">
                    <ul class="item_groupAll">
                        <li><img :src="require('../assets/cooperation/partner1.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner2.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner3.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner4.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner5.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner6.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner13.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner8.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner9.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner14.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner12.png')" alt=""/></li>
                        <li><img :src="require('../assets/cooperation/partner10.png')" alt=""/></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cooperativePartner"
    }
</script>

<style scoped>
img{
	width:auto;
	height: auto;
	max-width: 100%;
	max-height: 100%;
}
</style>
